import { Typography } from '@mui/material';

import { FONT_SECONDARY } from 'src/theme/typography';

//
//

interface Props {
  text: string;
}

const Title: React.FC<Props> = ({ text }) => {
  return (
    <Typography
      variant="title2"
      sx={{
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        color: (theme) => theme.palette.grey[500],
        fontFamily: FONT_SECONDARY,
        fontWeight: 300,
      }}
    >
      {text}
    </Typography>
  );
};

export default Title;
